/**
 * AskVeeCard — the dashboard's AI entry point (the "agentic-first" surface).
 *
 * A compact composer plus suggested prompts computed from the deadline engine
 * (never LLM-invented). Submitting starts a FRESH conversation — the page's
 * askVee() handles transport (ChatContext.sendTurn) and navigates to /agent,
 * where the reply is already streaming when the user lands.
 */

import { useState } from 'react';
import { FiArrowUp } from 'react-icons/fi';
import Card from '../common/Card';

export default function AskVeeCard({ suggestions = [], onAsk }) {
  const [input, setInput] = useState('');

  const submit = (text) => {
    const q = String(text || input).trim();
    if (!q) return;
    setInput('');
    onAsk(q);
  };

  return (
    <Card padded={false} className="mb-3.5 overflow-hidden">
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2.5">
          <img src="/vee-mascot.svg" alt="Vee" className="w-6 h-6 rounded-[8px]" style={{ boxShadow: '0 2px 6px -2px rgba(13,74,69,0.4)' }} />
          <span className="text-[17.5px] font-bold tracking-wide text-[#08111f]" style={{ fontFamily: 'var(--font-serif)' }}>
            Ask Vee
          </span>
          <span className="text-[10.5px] text-[#9a9080]">— your AI compliance expert</span>
        </div>

        <div
          className="flex items-center gap-2 rounded-xl border bg-white pl-3.5 pr-2 h-11 transition-all focus-within:border-[#145f5f] focus-within:shadow-[0_0_0_3px_rgba(20,95,95,0.1)]"
          style={{ borderColor: '#ddd6c6' }}
        >
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            placeholder="Ask a compliance question or request a draft…"
            className="flex-1 bg-transparent text-[13px] outline-none"
            style={{ fontFamily: "'Outfit', sans-serif" }}
            aria-label="Ask Vee"
          />
          <button
            type="button"
            onClick={() => submit()}
            disabled={!input.trim()}
            className="w-8 h-8 rounded-full flex items-center justify-center text-white shrink-0 transition-all active:scale-90 disabled:opacity-40"
            style={{ background: '#145f5f' }}
            aria-label="Ask Vee"
          >
            <FiArrowUp size={15} />
          </button>
        </div>

        {suggestions.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-2.5">
            {suggestions.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => submit(s)}
                className="text-[11px] font-medium px-2.5 py-1 rounded-full border transition-colors hover:border-[#145f5f] hover:text-[#145f5f] hover:bg-[rgba(20,95,95,0.04)] text-[#5a5145]"
                style={{ borderColor: '#e2d9c8', background: '#fdfcf9' }}
              >
                {s}
              </button>
            ))}
          </div>
        )}
      </div>
    </Card>
  );
}
